<template>
  <section class="section container">
    <div class="title is-3 has-text-centered">{{ $t("yaii") }}</div>
    <div class="grid is-col-min-10">
      <div class="cell" @click="warehouse">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/3061/3061160.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("warehouse") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell" @click="labeling">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/6755/6755065.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("labeling") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell" @click="branch_delivery">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://i.pinimg.com/564x/b3/d4/62/b3d462f67285b82dc8db44805e333a6c.jpg"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("branch delivery") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell" @click="branch_reception">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/1060/1060305.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("branch reception") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell" @click="customer_delivery">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/383/383980.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("customer delivery") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { warning_message, get } from "@/utils";

export default {
  name: "TailoringOrderIndex",
  components: {},
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    orders() {
      let v = this;
      v.$router.push({
        path: "/tailoring_order/orders",
      });
    },
    delivery() {
      let v = this;
      v.$router.push({
        path: "/tailoring_order/delivery",
      });
    },
    sewing() {
      let v = this;
      v.$router.push({
        path: "/tailoring_order/sewing",
      });
    },
    cutting() {
      let v = this;
      v.$router.push({
        path: "/tailoring_order/cutting",
      });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped>
.grid .cell .card:hover {
  border-radius: 0.5em;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: linear 0.1s;
  transform: scale(1.05, 1.05);
}
.grid .cell .card:active {
  border-radius: 20px;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: ease-out 0.3s;
  transform: scale(1.5, 1.5);
  opacity: 0;
}

.grid .cell .card {
  background-color: rgba(20, 22, 26, 0.4);
}
</style>
